import { NumberWithUnit } from './NumberWithUnit';
import { useTranslation } from 'react-i18next';

export function DimensionsInput({
  value,
  onChange,
}: {
  value: { length?: number; width?: number; height?: number } | undefined;
  onChange: (next: { length?: number; width?: number; height?: number } | undefined) => void;
}) {
  const { t } = useTranslation('intake');
  const v = value ?? {};
  const update = (k: 'length' | 'width' | 'height') => (n: number | undefined) => {
    const next = { ...v, [k]: n };
    if (next.length == null && next.width == null && next.height == null) onChange(undefined);
    else onChange(next);
  };
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1">
        <label className="text-[10px] text-synergy-text-tertiary">{t('dimensions.length')}</label>
        <NumberWithUnit value={v.length} onChange={update('length')} unit="mm" min={1} step={10} />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[10px] text-synergy-text-tertiary">{t('dimensions.width')}</label>
        <NumberWithUnit value={v.width} onChange={update('width')} unit="mm" min={1} step={10} />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[10px] text-synergy-text-tertiary">{t('dimensions.height')}</label>
        <NumberWithUnit value={v.height} onChange={update('height')} unit="mm" min={1} step={10} />
      </div>
    </div>
  );
}
